import React, {useState} from "react";
import { connect } from "react-redux";
import { setLoginDetails } from "../../action/set-action-details";
import Logo from "../../assets/img/logoo-.png";
import {HOTEL_NAME, HOTEL_CAPTION} from "../../context/connection-string";
import {Link} from "react-router-dom";
import {Audit, encryptData} from "../../context/function";
import {toast} from "react-toastify";
import { patch } from "../../services/api-client";
import Button from "../../component/button/button";
import { EnvelopeIcon, ArrowLeftIcon, KeyIcon } from "@heroicons/react/24/outline";

function ForgotPassword(props) {
    const [isLoading, setIsLoading] = useState(false);
    const [loginData, setLoginData] = useState({
        email_address: "",
        password: ""
    })

    const onHandleChange = (e) => {
        setLoginData({
            ...loginData,
            [e.target.id]: e.target.id === 'password' ? encryptData(e.target.value.trim()) : e.target.value.trim()
        })
    }

    const onSubmit = async (e) => {
        e.preventDefault();
        if (loginData.email_address === '') {
            toast.error("Please enter your registered email address");
            return false;
        }
        setIsLoading(true);
        const token = "pa" + Math.floor(Math.random() * 999999999);
        toast.info("Please wait...")
        try {
            const res = await patch(`login/forget_password/add_token/${loginData.email_address}`, { token: encryptData(token) }, { retry: false });
            if (res.data.message === "success") {
                toast.success('An email has been sent to your mailbox, please check and proceed.')
                setLoginData({ email_address: "", password: "" });
            } else if (res.data.message === "no email") {
                toast.error('Sorry!, your email address is not registered')
            } else {
                toast.error("Something went wrong. Please try again.")
            }
        } catch (e) {
            // Error message already shown by API client
            console.log(e)
        } finally {
            setIsLoading(false);
        }
    }

    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-indigo-600 via-purple-600 to-pink-500 dark:from-slate-900 dark:via-slate-800 dark:to-slate-900 px-4 sm:px-6 lg:px-8">
            {/* Background Pattern */}
            <div className="absolute inset-0 overflow-hidden">
                <div className="absolute -top-40 -right-40 w-80 h-80 bg-purple-300 dark:bg-purple-900 rounded-full mix-blend-multiply dark:mix-blend-soft-light filter blur-xl opacity-70 animate-blob"></div>
                <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-pink-300 dark:bg-pink-900 rounded-full mix-blend-multiply dark:mix-blend-soft-light filter blur-xl opacity-70 animate-blob animation-delay-2000"></div>
                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-80 h-80 bg-indigo-300 dark:bg-indigo-900 rounded-full mix-blend-multiply dark:mix-blend-soft-light filter blur-xl opacity-70 animate-blob animation-delay-4000"></div>
            </div>

            {/* Forgot Password Card */}
            <div className="relative w-full max-w-md">
                <div className="bg-white dark:bg-slate-800 rounded-2xl shadow-2xl p-8 sm:p-10 backdrop-blur-sm border border-white/20 dark:border-slate-700/50">
                    {/* Logo and Header */}
                    <div className="text-center mb-8">
                        <div className="inline-flex items-center justify-center w-20 h-20 mb-4 rounded-full bg-gradient-to-br from-indigo-500 to-purple-600 shadow-lg">
                            <KeyIcon className="w-10 h-10 text-white" />
                        </div>
                        <h1 className="text-3xl font-bold text-slate-900 dark:text-white mb-2">
                            Forgot Password?
                        </h1>
                        <p className="text-slate-600 dark:text-slate-400">
                            Enter your email address and we'll send you a link to reset your password.
                        </p>
                    </div>

                    {/* Form */}
                    <form onSubmit={onSubmit} className="space-y-6">
                        <div>
                            <label htmlFor="email_address" className="block text-sm font-semibold text-slate-700 dark:text-slate-300 mb-2">
                                Email Address
                            </label>
                            <div className="relative">
                                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                    <EnvelopeIcon className="h-5 w-5 text-slate-400" />
                                </div>
                                <input
                                    type="email"
                                    id="email_address"
                                    name="email_address"
                                    value={loginData.email_address}
                                    onChange={onHandleChange}
                                    placeholder="Enter your registered email address"
                                    required
                                    autoComplete="off"
                                    className="w-full pl-10 pr-4 py-2.5 border border-slate-300 dark:border-slate-600 rounded-lg bg-white dark:bg-slate-800 text-slate-900 dark:text-slate-100 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all duration-200"
                                />
                            </div>
                        </div>

                        <Button
                            type="submit"
                            size="lg"
                            fullWidth
                            isLoading={isLoading}
                            disabled={isLoading}
                            className="mt-6"
                        >
                            {isLoading ? "Sending..." : "Send Reset Link"}
                        </Button>

                        <div className="text-center">
                            <Link 
                                to="/" 
                                className="inline-flex items-center text-sm font-medium text-indigo-600 hover:text-indigo-500 dark:text-indigo-400 dark:hover:text-indigo-300 transition-colors duration-200"
                            >
                                <ArrowLeftIcon className="w-4 h-4 mr-2" />
                                Back to login
                            </Link>
                        </div>
                    </form>

                    {/* Footer */}
                    <div className="mt-8 text-center">
                        <p className="text-sm text-slate-500 dark:text-slate-400">
                            &copy; {new Date().getFullYear()} {HOTEL_NAME}. All rights reserved.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        loginData: state.LoginDetails,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setOnLoginDetails: (p) => {
            dispatch(setLoginDetails(p));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);